import { Component, ElementRef, Input, OnInit, VERSION, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FileUploadOptions } from 'bnsights-control-library';
import { LicenseService } from './../../shared/Services/LicenseService.service';
import { FormGroup } from '@angular/forms';
import { LicenseModel } from '../../shared/models/LicenseModel/LicenseModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.css'],
  //animations: [
  //  trigger('flip', [
  //    transition('*=>*', [
  //      animate(
  //        '.6s',
  //        keyframes([
  //          style({ transform: 'rotateX(130deg)', offset: 0 }),
  //          style({ transform: 'rotateX(0deg)', offset: 0.45 }),
  //          style({ transform: 'rotateX(7deg)', offset: 0.5 }),
  //          style({ transform: 'rotateX(0deg)', offset: 0.53 }),
  //          style({ transform: 'rotateX(5deg)', offset: 0.56 }),
  //          style({ transform: 'rotateX(0deg)', offset: 0.6 }),
  //          style({ transform: 'rotateX(0deg)', offset: 0.95 }),
  //          style({ transform: 'rotateX(0deg)', offset: 1 })
  //        ])
  //      )
  //    ])
  //  ])
  //]
})
export class LicenseComponent implements OnInit {
 
  ShowPageContent = false;
  change: boolean = false;
  showShadow = [];
  noLicenseFound:boolean=false;
  ActivationDate:string;
  LicenseStartDate:string;
  LicenseEndDate:string; 
  Name:string=""; 
  language:string=""
  ProductionMode: boolean = false;
  DateInMinutes:number=0

  seconds:number=0;
  minutes:number=0;
  hours :number=0;
  days :number=0;
  weeks:number=0;
  months:number=0;
  years:number=0;
  date_future:any;
  date_now:any;
  ShowTimer:boolean=false;
    //Upload Model Controls
    UploadFileForm = new FormGroup({});
    LicenseFileInput: FileUploadOptions;
    @ViewChild('CloseLicenseFileModal', { static: false }) CloseLicenseFileModal: ElementRef;


   // Decorator wires up blockUI instance
  initialMinutes$ =new BehaviorSubject(24*60*30); ;
  @Input()
  // set minutes(val) {
  //   this.initialMinutes$.next(val);
  // }
  value = 0;
  timer$:any
  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,  private LicenseService: LicenseService, private modalService: NgbModal)
   { 
     
   }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("License")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.GetOrganizationLicense();

   }
  
  
 
  GetOrganizationLicense() {
    this.LicenseService.GetOrganizationLicense().subscribe((result) => {
      let Model = result as any 
      if(Model!= null)  {
        let startDate= new Date(Model.val.licenseStartDate);
        let endDate= new Date(Model.val.licenseEndDate);
        let activationDate=new Date(Model.val.activationDate);
        this.ActivationDate=activationDate.toLocaleDateString();
        this.LicenseStartDate=startDate.toLocaleDateString()
        this.LicenseEndDate=endDate.toLocaleDateString()
        this.Name=Model.val.name.current
       let CurrentDate=new Date();
        if((activationDate.toLocaleDateString() == CurrentDate.toLocaleDateString()))
          this.noLicenseFound=true
        else
          this.noLicenseFound=false

          this.DateInMinutes=this.getDifferenceInMinutes(CurrentDate,endDate);

          setInterval(()=>{
            this.date_future = endDate;
            this.date_now = new Date();
    
            this.seconds = Math.floor((this.date_future - (this.date_now))/1000);
            this.minutes = Math.floor(this.seconds/60);
            this.hours   = Math.floor(this.minutes/60);
            this.days    = Math.floor(this.hours/24);
            this.months = Math.floor(this.days/31);
            this.years = Math.floor(this.months/12);
           
            this.hours = this.hours-(this.days*24);
            this.minutes = this.minutes-(this.days*24*60)-   (this.hours*60);
            this.seconds = this.seconds-(this.days*24*60*60)-(this.hours*60*60)-(this.minutes*60);
            this.days=this.days-(this.months*31);
            this.months=this.months-(this.years*12);
        },1000);
          
      }
     
      setTimeout(() => {
        this.ShowTimer=true
      }, 1000);
    })
  }


 getDifferenceInMinutes(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60);
  }

  
  ShowUploadModal(UploadFileModa) {
    this.utilityService.startBlockUI();
    this.UploadFileForm.reset();
    this.LicenseFileInput = new FileUploadOptions();
    this.LicenseFileInput.Name = "LicenseFileInput"
    this.LicenseFileInput.LabelKey = "UploadFile"
    this.LicenseFileInput.IsMultipleFile = false
    this.LicenseFileInput.IsRequired = true
    this.modalService.open(UploadFileModa);
    this.utilityService.stopBlockUI();

  }


  UploadFiles(appendExisting) {
    if (this.UploadFileForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.UploadFileForm.value;
  
      let Model = new LicenseModel();

      Model.appendExisting = appendExisting;
      Model.LicenseFile = {
        FileBase64:ResultModel["LicenseFileInput"][0].FileBase64,
        FileName:ResultModel["LicenseFileInput"][0].FileName,
        FileSizeInMB:ResultModel["LicenseFileInput"][0].FileSizeInMB,
        FileType:ResultModel["LicenseFileInput"][0].FileType
      }

      


      this.LicenseService.UploadLicense(Model).subscribe((result) => {
        let Result= result as any
        this.UploadFileForm.reset()
        this.modalService.dismissAll();


      }, (error) => {
       
      })
    }
  }

}
